<template>
    <div>
        <HeaderComponent />
        <div class="user-support container text-center">
            <div class="row">
                <div class="col field">
                    <label for="email">Email</label>
                    <input type="email" id="email" v-model="email" placeholder="Enter email" />
                </div>
                <div class="col field">
                    <label for="phone">Phone</label>
                    <input type="text" id="phone" v-model="phone" placeholder="Enter phone number" />
                </div>
                <div class="col field">
                    <label for="search">Search</label>
                    <input type="text" id="search" v-model="searchText" placeholder="Enter search text" />
                </div>
            </div>
            <div class="row">
                <div class="col field">
                    <label for="username">Username</label>
                    <input type="text" id="username" v-model="username" placeholder="Enter username" />
                </div>
                <div class="col field">
                    <label for="userId">User ID</label>
                    <input type="text" id="userId" v-model="userId" placeholder="Enter User ID" />
                </div>
                <div class="col field">
                    <label for="tenants">Tenants</label>
                    <v-select v-model="selectedTenant" :options="tenants" label="name" placeholder="Select TenantID" />
                </div>
            </div>
            <div class="button-wrapper">
                <button @click="downloadAttendanceReport" class="fetch-button" :disabled="isDownloadAttendanceReportLoading">
                    <b-spinner v-if="isDownloadAttendanceReportLoading" small type="grow"></b-spinner>
                    <span v-else>
                        <i class="bi bi-download" style="margin-right: 8px;"></i> Attendance Report
                    </span>
                </button>
            </div>
            <div class="fetch-parent-button row mt-3">
                <button @click="fetchData" class="fetch-button" :disabled="isLoading">
                    <b-spinner v-if="isLoading" small type="grow"></b-spinner>
                    <span v-else>Fetch</span>
                </button>
            </div>
        </div>
        <div v-if="isLoading" class="text-center mt-4">
            <b-spinner></b-spinner>
            <p>Fetching user data...</p>
        </div>
        <UserSupportDataTable v-if="!isLoading" :userData="userData" :tenantId="selectedTenant?.name" />
    </div>
</template>

<script>
import HeaderComponent from '../Layout/HeaderComponent.vue';
import { GetAllTenants } from '../../Helper/TenantApiHelper';
import { GetUserDataByTenantID } from '../../Helper/ContentApiHelper';
import {GetUserAttendanceReport} from '../../Helper/UserApiHelper';
import UserSupportDataTable from './UserSupportDataTable.vue';

export default {
    name: 'UserSupport',
    components: {
        HeaderComponent, UserSupportDataTable
    },
    data() {
        return {
            email: '',
            phone: '',
            searchText: '',
            userId: '',
            username: '',
            tenants: [],
            selectedTenant: null,
            userData: [],
            isLoading: false,
            isDownloadAttendanceReportLoading:false
        };
    },
    methods: {
        async getAllTenant() {
            try {
                const tenants = await GetAllTenants();
                this.tenants = tenants.map(tenant => ({ value: tenant.id, name: tenant.name }));
            } catch (error) {
                console.error(error);
            }
        },
        async fetchData() {
            try {
                if (!this.selectedTenant) {
                    this.$toasted.error("Please select a Tenant. It is required.", {
                        icon: "exclamation-triangle",
                        theme: "outline",
                        position: "bottom-center",
                        singleton: true,
                        duration: 3000,
                    });
                    return;
                }
                if (!this.email && !this.phone && !this.searchText && !this.userId && !this.username) {
                    this.$toasted.error("Please provide at least one more field along with the Tenant.", {
                        icon: "exclamation-triangle",
                        theme: "outline",
                        position: "bottom-center",
                        singleton: true,
                        duration: 3000,
                    });
                    return;
                }

                this.isLoading = true; 

                const userData = {
                    email: this.email || null,
                    phone: this.phone || null,
                    searchText: this.searchText || null,
                    userID: this.userId || null,
                    Username: this.username || null,
                    tenantID: this.selectedTenant ? this.selectedTenant.name : null,
                };

                const response = await GetUserDataByTenantID(userData);
                if (response != null) {
                    console.log(response);
                    this.$toasted.success("Fetched Successfully!", {
                        theme: "outline",
                        position: "bottom-center",
                        duration: 3000,
                    });
                    this.userData = response;
                } else {
                    throw new Error("There was a problem fetching data. Please try again later.");
                }
            } catch (error) {
                console.error(error);
                this.$toasted.error(error.message || "An unexpected error occurred.", {
                    icon: "exclamation-triangle",
                    theme: "outline",
                    position: "bottom-center",
                    singleton: true,
                    duration: 3000,
                });
            } finally {
                this.isLoading = false; 
            }
        },
        async downloadAttendanceReport() {
            if (!this.selectedTenant) {
                this.$toasted.error("Please select a Tenant. It is required.", {
                    icon: "exclamation-triangle",
                    theme: "outline",
                    position: "bottom-center",
                    singleton: true,
                    duration: 3000,
                });
                return;
            }

            if (!this.email) {
                this.$toasted.error("Please provide Email. It is required.", {
                    icon: "exclamation-triangle",
                    theme: "outline",
                    position: "bottom-center",
                    singleton: true,
                    duration: 3000,
                });
                return;
            }

            this.isDownloadAttendanceReportLoading = true;

            try {
                const queryParams = new URLSearchParams({
                    UserEmail: this.email,
                    TenantID: this.selectedTenant.name
                });
                const response = await GetUserAttendanceReport(queryParams);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const blob = await response.blob();
                let fileName = "AttendanceReport.xlsx";
                const contentDisposition = response.headers.get("Content-Disposition");
                if (contentDisposition && contentDisposition.includes("filename=")) {
                    const match = contentDisposition.match(/filename="?(.+)"?/);
                    if (match && match[1]) {
                        fileName = match[1];
                    }
                }
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);
            } catch (error) {
                console.error(error);
                this.$toasted.error("Failed to download attendance report.", {
                    icon: "exclamation-triangle",
                    theme: "outline",
                    position: "bottom-center",
                    singleton: true,
                    duration: 3000,
                });
            } finally {
                this.isDownloadAttendanceReportLoading = false;
            }
        }

    },
    created() {
        this.getAllTenant();
    },
};
</script>


<style scoped>
.user-support{
    
    min-height: 50vh;
    display: flex;
    flex-direction: column;
    justify-content: center;

}
.field {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 300px;
}

.field input,
.field .v-select {
    padding: 0.75rem;
    font-size: 1rem;
    border-radius: 8px;
    border: 1px solid #ccc;
    outline: none;
}

.field input:focus,
.field .v-select--single:focus {
    border-color: #007bff;
}

.fetch-button {
    background-color: #007bff;
    color: #fff;
    padding: 0.75rem;
    font-size: 1rem;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    width: 30%;
    transition: background-color 0.3s;
}

.fetch-button:hover {
    background-color: #0056b3;
}
.field label{
    margin-top: 1rem;
    font-family: 'Times new roman';
    align-self: flex-start;
}
.fetch-parent-button{
    justify-content: center;
}
.row input,.v-select {
    border: 2px solid black !important;
}
.button-wrapper {
  width: 75%;
  margin: 0 auto;             
  display: flex;
  justify-content: center;    
}
</style>